import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import MyPic from '../../assets/images/my_pic.jpg'
import FrontResume from '../../assets/files/Rajitha_Front_Resume.pdf'
import MLResume from '../../assets/files/Rajitha_ML_Resume.pdf'
import AndroidResume from '../../assets/files/Rajitha_Android_Resume.pdf'
//import Logo from './Logo'
import './index.scss'

const Home = () => {
  const queryParameters = new URLSearchParams(window.location.search)
  const type = queryParameters.get('type')
  console.log('type', type)
  const [letterClass, setLetterClass] = useState('text-animate')

  const nameArray = [' ', 'R', 'a', 'j', 'i', 't', 'h', 'a', '.']
  const jobArray = [
    'w',
    'e',
    'b',
    ' ',
    'd',
    'e',
    'v',
    'e',
    'l',
    'o',
    'p',
    'e',
    'r',
    '.',
  ]

  //   useEffect(() => {
  //     return setTimeout(() => {
  //       setLetterClass('text-animate-hover')
  //     }, 4000)
  //   }, [])

  const onButtonClick = () => {
    let MyResume = FrontResume
    // using Java Script method to get PDF file
    if (type === 'machine-learning') {
      MyResume = MLResume
    } else if (type === 'android') {
      MyResume = AndroidResume
    } else {
      MyResume = FrontResume
    }
    fetch(MyResume).then((response) => {
      response.blob().then((blob) => {
        // Creating new object of PDF file
        const fileURL = window.URL.createObjectURL(blob)
        // Setting various property values
        let alink = document.createElement('a')
        alink.href = fileURL
        alink.download = MyResume
        alink.click()
      })
    })
  }

  return (
    <>
      <div className="container home-page">
        <div className="text-zone">
          <h1>
            <span className={letterClass}>H</span>
            <span className={`${letterClass} _12`}>i,</span>
            <br />
            <span className={`${letterClass} _13`}>I</span>
            <span className={`${letterClass} _14`}>'m</span>
            {/* <img
              src={LogoTitle}
              alt="JavaScript Developer Name, Web Developer Name"
            /> */}
            <AnimatedLetters
              letterClass={letterClass}
              strArray={nameArray}
              idx={15}
            />
            <br />
            {/* <AnimatedLetters
              letterClass={letterClass}
              strArray={jobArray}
              idx={22}
            /> */}
          </h1>
          <h2>
            Front-end Developer / Android Developer / Machine Learning Scientist
          </h2>
          <button onClick={onButtonClick} className="flat-button">
            RESUME
          </button>
        </div>

        {/* <Logo /> */}
      </div>
      <img
        className="image-zone"
        src={MyPic}
        alt="JavaScript Developer Name, Web Developer Name"
      />

      <Loader type="pacman" />
    </>
  )
}

export default Home
